import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Container,
  ListGroup,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Table,
} from "react-bootstrap";
import S3Image from "../base/S3Image";
import {
  EDIT_ADJUNTO_SERVICIO,
  DELETE_ADJUNTO_SERVICIO,
  ADD_ADJUNTO_SERVICIO,
  UPDATE_ESTADO_SERVICIO,
} from "./../../utils/graphql_mutation";
import ButtonIcon from "../../components/base/ButtonIcon";
import { useMutation } from "@apollo/client";
import _ from "lodash";
import {
  uploadFileS3,
  uploadImgS3,
  getCountryById,
  getStatesById,
  getCityById,
} from "../../utils/helpers";
import { SERVICE_EMPRESA_FIND_ID } from "../../utils/graphql_query";
import { useQuery } from "@apollo/client";
import CrudServicio from "../servicio/CrudServicio";
import useCities from "../../hooks/useCities";

export const ShowServicio = ({ servicioId, setShowAccion }) => {
  // VARIABLE
  const initialState = {
    servicio: {},
  };
  // STATE
  const [modDelete, setModDelete] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [modEditImg, setModEditImg] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState("");
  const [modEditAdjunto, setModEditAdjunto] = useState(false);
  const [isEditingAdjunto, setIsEditingAdjunto] = useState(false);
  const [selectedService, setSelectedService] = useState({});
  const [verificadorAdjunto, setVerificadorAdjunto] = useState(false);
  const [state, setState] = useState(initialState.servicio);
  const [countryStateCity, setCountryStateCity] = useState({
    country: [],
    state: [],
    city: [],
  });
  const [adjuntoServicio, setAdjuntoServicio] = useState({ img: [], doc: [] });
  const [previewImage, setPreviewImage] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  // Estados para modal de adjuntos
  const [previewAdjunto, setPreviewAdjunto] = useState(null);
  const [isDraggingAdjunto, setIsDraggingAdjunto] = useState(false);
  const fileInputAdjuntoRef = useRef(null);
  // QUERY
  const {
    loading: loadingQuery,
    data: dataQuery,
    refetch: refetchQuery,
  } = useQuery(SERVICE_EMPRESA_FIND_ID, {
    variables: { id: servicioId },
  });
  // MUTATION
  const [editAdjuntoServicio] = useMutation(EDIT_ADJUNTO_SERVICIO);
  const [deleteAdjuntoServicio] = useMutation(DELETE_ADJUNTO_SERVICIO);
  const [addAdjuntoServicio] = useMutation(ADD_ADJUNTO_SERVICIO);
  const [editEstadoServicio, { loading: loadingEditEstadoServicio }] =
    useMutation(UPDATE_ESTADO_SERVICIO);
  // CUSTOM HOOKS
  const [getCities, { loading: loadCities, data: dataCities }] = useCities();
  // FUNCTION
  const handleImageFile = useCallback((file) => {
    if (file && file.type.startsWith("image/")) {
      setSelectedFiles(file);
      const previewUrl = URL.createObjectURL(file);
      setPreviewImage(previewUrl);
    }
  }, []);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    handleImageFile(file);
  };

  const selectFileService = (event) => {
    const file = event.target.files[0];
    handleImageFile(file);
  };

  // Funciones para modal de adjuntos
  const handleDragOverAdjunto = (e) => {
    e.preventDefault();
    setIsDraggingAdjunto(true);
  };

  const handleDragLeaveAdjunto = (e) => {
    e.preventDefault();
    setIsDraggingAdjunto(false);
  };

  const handleDropAdjunto = (e) => {
    e.preventDefault();
    setIsDraggingAdjunto(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type === "application/pdf") {
      setPreviewAdjunto({
        name: file.name,
        size: file.size,
        file: file,
      });
      document.getElementById("lbDocAlert").style.display = "none";
    } else {
      alert("Solo se aceptan archivos de tipo PDF");
    }
  };

  const selectFileAdjunto = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/pdf") {
      setPreviewAdjunto({
        name: file.name,
        size: file.size,
        file: file,
      });
      document.getElementById("lbDocAlert").style.display = "none";
    } else {
      alert("Solo se aceptan archivos de tipo PDF");
      event.target.value = "";
    }
  };

  const clearPreviewAdjunto = () => {
    setPreviewAdjunto(null);
    if (fileInputAdjuntoRef.current) {
      fileInputAdjuntoRef.current.value = "";
    }
  };

  const updateEstadoServicio = async (newEstado) => {
    await editEstadoServicio({
      variables: {
        id: state.id,
        estado: newEstado,
      },
    });
    refetchQuery();
  };

  const updateServiceFile = async () => {
    if (!selectedFiles) {
      alert("Por favor, selecciona una imagen.");
      return;
    }

    try {
      setBtnLoading(true);

      // 1. Subir primero a S3 usando uploadImgS3
      const resultPortada = await uploadImgS3({
        data: selectedFiles,
        filename: selectedFiles.name,
        prefix: "servicio",
      });

      if (!resultPortada.success) {
        setBtnLoading(false);
        alert("Error al subir la imagen.");
        return;
      }

      // 2. Guardar en GraphQL con el nombre que devolvió S3
      const s3Key = resultPortada.key;

      if (_.size(adjuntoServicio.img) > 0) {
        // EDITAR
        await editAdjuntoServicio({
          variables: {
            id: adjuntoServicio.img[0].id,
            nombre: s3Key,
          },
        });
      } else {
        // AGREGAR
        await addAdjuntoServicio({
          variables: {
            tipo: "img",
            nombre: s3Key,
            descripcion: "",
            servicio_id: state.id,
          },
        });
      }

      refetchQuery();
      setModEditImg(false);
      setPreviewImage(null); // Limpiar preview
    } catch (error) {
      console.log("FAILURE!!");
      console.log(error);
      alert("Ocurrió un error al guardar la imagen.");
    } finally {
      setBtnLoading(false);
    }
  };

  const saveAdjuntoService = async () => {
    if (verificadorAdjunto) {
      setVerificadorAdjunto(true);
    }
    setBtnLoading(true);
    var descripcion = document.getElementById("adjuntoDescriptionDoc");
    var can_save = true;

    if (isEditingAdjunto) {
      if (!descripcion.value.trim()) {
        var lbAlert = document.getElementById("lbDocAlert");
        lbAlert.style = "display:block";
        lbAlert.style = "color:#dc3545";
        can_save = false;
      }

      if (can_save) {
        try {
          if (previewAdjunto && previewAdjunto.file) {
            const fileInput = previewAdjunto.file;
            const resultDoc = await uploadFileS3({
              data: fileInput,
              filename: "file.pdf",
              prefix: "servicio",
            });

            if (!resultDoc.success) {
              setBtnLoading(false);
              return;
            }

            const s3Key = resultDoc.key;
            await editAdjuntoServicio({
              variables: {
                id: selectedService.id,
                nombre: s3Key,
                descripcion: _.trim(descripcion.value),
              },
            });
          } else if (!previewAdjunto) {
            await editAdjuntoServicio({
              variables: {
                id: selectedService.id,
                descripcion: _.trim(descripcion.value),
              },
            });
          } else {
            setBtnLoading(false);
            alert("Por favor, selecciona un archivo.");
            return;
          }

          refetchQuery();
          setModEditAdjunto(false);
          setPreviewAdjunto(null);
          setBtnLoading(false);
        } catch (error) {
          setBtnLoading(false);
          console.log(error);
        }
      }
    } else {
      if (!previewAdjunto) {
        var lbAlert = document.getElementById("lbDocAlert");
        lbAlert.style = "display:block";
        lbAlert.style = "color:#dc3545";
        can_save = false;
      }

      if (can_save) {
        try {
          const fileInput = previewAdjunto.file;

          // 1. Subir primero a S3
          const resultDoc = await uploadFileS3({
            data: fileInput,
            filename: "file.pdf",
            prefix: "servicio",
          });

          if (!resultDoc.success) {
            setBtnLoading(false);
            return;
          }

          // 2. Guardar en GraphQL con el nombre que devolvió S3
          const s3Key = resultDoc.key;

          const {
            data: { addAdjuntoServicio: resultaddAdjuntoServicio },
          } = await addAdjuntoServicio({
            variables: {
              tipo: "doc",
              nombre: s3Key,
              descripcion: _.trim(descripcion.value),
              servicio_id: state.id,
            },
          });

          refetchQuery();
          setModEditAdjunto(false);
          setPreviewAdjunto(null);
          setBtnLoading(false);
        } catch (error) {
          setBtnLoading(false);
          console.log(error);
        }
      }
    }
  };
  const deleteAdjuntoService = async () => {
    setBtnLoading(true);
    const resultDelete = await deleteAdjuntoServicio({
      variables: { id: selectedService.id },
    });
    if (resultDelete) {
      refetchQuery();
      setModDelete(false);
    }
    setBtnLoading(false);
  };
  const handleSelectedService = (adjunto) => {
    setSelectedService(adjunto);
    setModDelete(true);
  };

  const handleEditAdjunto = (adjunto) => {
    setSelectedService(adjunto);
    setIsEditingAdjunto(true);
    setModEditAdjunto(true);
  };

  const openAddAdjunto = () => {
    setSelectedService({});
    setIsEditingAdjunto(false);
    setModEditAdjunto(true);
  };
  const handleVerificarAdjunto = (e) => {
    var target = e.target;
    var type = target.type;
    if (type === "file" && target.files.length !== 0) {
      if (target.files[0].type === "application/pdf") {
        document.getElementById("lbDocAlert").style = "display:none";
      } else {
        target.value = "";
        alert("Solo se aceptan archivo de tipo PDF");
      }
    }
  };
  const onError = (e) => {
    if (e.target.onerror === null) e.target.src = "../not-available.png";
  };
  const renderAdjunto = (nameFile) => {
    if (!nameFile) {
      return null;
    }
    const folderTest = process.env.REACT_APP_AWS_S3_FOLDER_TEST
      ? process.env.REACT_APP_AWS_S3_FOLDER_TEST
      : "";
    return `${process.env.REACT_APP_AWS_S3_URL}/servicio${folderTest}/${nameFile}`;
  };
  const handleEditDetail = () => {
    setShowModal(true);
    if (_.size(countryStateCity.country) > 0) {
      let newVal = { countryId: countryStateCity.country[0].id };
      if (_.size(countryStateCity.state) > 0) {
        newVal = { stateId: countryStateCity.state[0].id };
      }
      getCities(newVal);
    }
  };

  // EFFECT
  useEffect(() => {
    if (dataQuery) {
      const dataServicioQuery = dataQuery.servicio_empresa;
      setState(dataServicioQuery);
      // COUNTRY, STATE, CITY
      if (dataServicioQuery.pais_id) {
        const country = getCountryById(dataServicioQuery.pais_id);
        let auxCSC = { country: [country], state: [], city: [] };
        // Departamento
        if (dataServicioQuery.departamento_id) {
          const staties = getStatesById(dataServicioQuery.departamento_id);
          auxCSC = { ...auxCSC, state: [staties] };
        }
        // Ciudad
        if (dataServicioQuery.ciudad_id) {
          const cities = dataServicioQuery.city
            ? dataServicioQuery.city
            : getCityById(dataServicioQuery.ciudad_id);
          auxCSC = { ...auxCSC, city: [cities] };
        }
        setCountryStateCity(auxCSC);
      }
      // ADJUNTO SERVICIO
      if (dataServicioQuery.adjuntos) {
        let arrImg = [];
        let arrDoc = [];
        _.map(dataServicioQuery.adjuntos, (adj) => {
          if (adj.tipo && adj.tipo.trim() === "img") {
            arrImg.push(adj);
          }
          if (adj.tipo && adj.tipo.trim() === "doc") {
            arrDoc.push(adj);
          }
        });
        setAdjuntoServicio({ img: arrImg, doc: arrDoc });
      }
    }
  }, [dataQuery]);

  // EFFECT - Manejar pegar imagen
  useEffect(() => {
    const handlePaste = (e) => {
      if (!modEditImg) return;
      const items = e.clipboardData?.items;
      if (!items) return;

      for (let item of items) {
        if (item.type.startsWith("image/")) {
          const file = item.getAsFile();
          handleImageFile(file);
          break;
        }
      }
    };

    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, [modEditImg, handleImageFile]);

  // EFFECT - Cargar datos del adjunto en el modal de edición
  useEffect(() => {
    if (modEditAdjunto && isEditingAdjunto && selectedService) {
      const descripcionInput = document.getElementById("adjuntoDescriptionDoc");
      if (descripcionInput && selectedService.descripcion) {
        descripcionInput.value = selectedService.descripcion;
      }
      setPreviewAdjunto(null);
      if (fileInputAdjuntoRef.current) {
        fileInputAdjuntoRef.current.value = "";
      }
    } else if (modEditAdjunto && !isEditingAdjunto) {
      const descripcionInput = document.getElementById("adjuntoDescriptionDoc");
      if (descripcionInput) {
        descripcionInput.value = "";
      }
      setPreviewAdjunto(null);
      if (fileInputAdjuntoRef.current) {
        fileInputAdjuntoRef.current.value = "";
      }
    }
  }, [modEditAdjunto, isEditingAdjunto, selectedService]);

  // RENDER
  if (loadingQuery) {
    return "Cargando...";
  }
  const btnDisabled = btnLoading ? true : false;
  const styleVolver = { width: "100px", height: "37px" };
  const closeModalAdjunto = () => {
    setModEditAdjunto(false);
    setIsEditingAdjunto(false);
    setSelectedService({});
    setPreviewAdjunto(null);
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <Button
          className="mb-3"
          style={styleVolver}
          onClick={() => setShowAccion("listar_servicio")}
        >
          <i className="fas fa-chevron-left"></i> Atras
        </Button>
        <div className="d-flex flex-column text-center">
          <Form>
            <Form.Check
              type="switch"
              id="active-switch"
              disabled={loadingEditEstadoServicio}
              checked={state.estado}
              onClick={() => updateEstadoServicio(state.estado ? 0 : 1)}
              style={{ transform: "scale(1.6)" }}
            />
          </Form>
          <span className="pr-2">{state.estado ? "Activo" : "Inactivo"}</span>
        </div>
      </div>
      <h5>Imagen de Portada</h5>
      <Container className="shadow p-4 bg-white rounded mb-2">
        <div className="card">
          <div className="row no-gutters">
            <div
              className="col-md-12 text-center"
              style={{ background: "#f2f2f2" }}
            >
              {state.adjuntos && state.adjuntos.length > 0 ? (
                (() => {
                  const img = _.find(state.adjuntos, { tipo: "img" });
                  return img ? (
                    <S3Image
                      src={img.nombre_archivo}
                      folder="servicio"
                      alt="Imagen del servicio"
                      style={{ height: "400px" }}
                      fluid
                    />
                  ) : (
                    <S3Image
                      src={null}
                      alt="Imagen no disponible"
                      style={{ height: "400px" }}
                      fluid
                    />
                  );
                })()
              ) : (
                <S3Image
                  src={null}
                  alt="Imagen no disponible"
                  style={{ height: "400px" }}
                  fluid
                />
              )}
            </div>
          </div>
        </div>
      </Container>

      <Container className="text-end mb-3 p-0">
        <Button onClick={() => setModEditImg(true)} className="mb-3">
          Editar
        </Button>
      </Container>

      <label style={{ fontSize: "1.25rem", fontWeight: "500" }}>Detalles</label>

      <Container className="shadow p-4 bg-white rounded mb-2">
        <ListGroup variant="flush">
          <ListGroup.Item>
            <Row>
              <Col sm="6" className="my-auto">
                <b>Titulo</b>
                <h6 className="text-secondary mt-2">{state.titulo}</h6>
              </Col>
              <Col sm="6" className="my-auto">
                <b>Precio Aprox.</b>
                <h6 className="text-secondary mt-2">
                  {`${_.round(Number(state.precio), 2)} ${_.toUpper(
                    state.moneda
                  )}`}
                </h6>
              </Col>
            </Row>
          </ListGroup.Item>

          <ListGroup.Item>
            <b>Descripcion</b>
            <h6 className="text-secondary mt-2">{state.descripcion}</h6>
          </ListGroup.Item>

          <ListGroup.Item>
            <Row>
              <Col sm="4" className="my-auto">
                <b>Pais</b>
                <h6 className="text-secondary mt-2">
                  {_.size(countryStateCity.country) > 0 &&
                    countryStateCity.country[0].name}
                </h6>
              </Col>

              {_.size(countryStateCity.state) > 0 && (
                <Col sm="4" className="my-auto">
                  <b>Departamento</b>
                  <h6 className="text-secondary mt-2">
                    {countryStateCity.state[0].name}
                  </h6>
                </Col>
              )}

              {_.size(countryStateCity.city) > 0 && (
                <Col sm="4" className="my-auto">
                  <b>Ciudad</b>
                  <h6 className="text-secondary mt-2">
                    {countryStateCity.city[0].name}
                  </h6>
                </Col>
              )}
            </Row>
          </ListGroup.Item>

          <ListGroup.Item>
            <b>Atracciones Turisticas</b>
            <h6 className="text-secondary mt-2">
              {_.map(state.atracciones, (val, ka) => {
                return ka === 0 ? (
                  val.nombre
                ) : (
                  <span key={ka}>
                    <b className="ms-2 me-2"> / </b>
                    {val.nombre}
                  </span>
                );
              })}
            </h6>
          </ListGroup.Item>

          <ListGroup.Item>
            <b>Nro de Dias</b>
            <h6 className="text-secondary mt-2">{state.nro_dias}</h6>
          </ListGroup.Item>
        </ListGroup>
      </Container>

      <Container className="text-end mb-3 p-0">
        <Button onClick={handleEditDetail} className="mb-3">
          Editar
        </Button>
      </Container>

      <h5>Adjuntos</h5>
      <Table striped bordered hover className="shadow bg-white">
        <thead>
          <tr className="text-center">
            <th>Nombre</th>
            <th>Tipo</th>
            <th>Descripcion</th>
            <th>Acci&oacute;n</th>
          </tr>
        </thead>
        <tbody>
          {state.adjuntos ? (
            _.map(state.adjuntos, (val, i) => {
              return (
                val.tipo !== "img" && (
                  <tr key={i}>
                    <td>{val.nombre_archivo}</td>
                    <td>{val.tipo}</td>
                    <td>{val.descripcion}</td>
                    <td className="text-center">
                      <ButtonIcon
                        size="sm"
                        titulo={"Descargar"}
                        icono={"fa fa-download"}
                        variant={"primary"}
                        onClick={() =>
                          window.open(
                            renderAdjunto(val.nombre_archivo),
                            "_blank"
                          )
                        }
                      />

                      <ButtonIcon
                        size="sm"
                        className="ms-1"
                        titulo={"Editar"}
                        icono={"fa fa-edit"}
                        variant={"warning"}
                        onClick={() => handleEditAdjunto(val)}
                      />

                      <ButtonIcon
                        size="sm"
                        className="ms-1"
                        titulo={"Eliminar"}
                        icono={"fa fa-trash"}
                        variant={"danger"}
                        onClick={() => handleSelectedService(val)}
                      />
                    </td>
                  </tr>
                )
              );
            })
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                No existen adjuntos registrados.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <Container className="text-end mb-3 p-0">
        <Button onClick={openAddAdjunto} className="mb-3">
          Agregar
        </Button>
      </Container>

      {showModal && (
        <CrudServicio
          servicio={state}
          selectCountryStateCity={countryStateCity}
          onClose={() => setShowModal(false)}
          onRefresh={refetchQuery}
          dataCities={dataCities}
          loadCities={loadCities}
          getCities={getCities}
        />
      )}

      <Modal
        show={modDelete}
        onHide={() => setModDelete(false)}
        backdrop="static"
        size="md"
      >
        <Modal.Body className="p-4">
          <div>Se Necesita Confirmaci&oacute;n Para Eliminar.</div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModDelete(false)}>
            Salir
          </Button>
          <Button
            variant="primary"
            disabled={btnDisabled}
            onClick={() => deleteAdjuntoService()}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modEditImg}
        onHide={() => {
          setModEditImg(false);
          setPreviewImage(null); // Limpiar preview al cerrar
        }}
        backdrop="static"
        size="md"
      >
        <Modal.Header className="h4">Editar - Imagen</Modal.Header>
        <Modal.Body className="p-4">
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={selectFileService}
            style={{ display: "none" }}
          />
          {previewImage ? (
            <div className="text-center mb-3">
              <img
                src={previewImage}
                alt="Preview"
                style={{ maxWidth: "100%", height: "auto", maxHeight: "250px" }}
              />
            </div>
          ) : (
            <div
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              style={{
                border: isDragging
                  ? "3px dashed #0d6efd"
                  : "3px dashed #dee2e6",
                borderRadius: "8px",
                padding: "40px 20px",
                textAlign: "center",
                backgroundColor: isDragging ? "#f8f9fa" : "transparent",
                transition: "all 0.2s ease",
                cursor: "pointer",
              }}
              onClick={() => fileInputRef.current.click()}
            >
              <div className="mb-3">
                <i
                  className={`fas fa-cloud-upload-alt fa-3x ${isDragging ? "text-primary" : "text-muted"}`}
                ></i>
              </div>
              <p
                className="mb-2"
                style={{ fontSize: "14px", color: "#6c757d" }}
              >
                Arrastra una imagen aquí
              </p>
              <p
                className="mb-2"
                style={{ fontSize: "14px", color: "#6c757d" }}
              >
                o
              </p>
              <ButtonIcon
                text="Cargar imagen"
                variant="primary"
                icono="fas fa-upload"
              />
              <p
                className="mt-3 mb-0"
                style={{ fontSize: "12px", color: "#adb5bd" }}
              >
                También puedes pegar una imagen (Ctrl+V)
              </p>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={btnDisabled}
            onClick={() => setModEditImg(false)}
          >
            Salir
          </Button>
          <Button
            variant="primary"
            disabled={btnDisabled}
            onClick={updateServiceFile}
          >
            Modificar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modEditAdjunto}
        onHide={closeModalAdjunto}
        backdrop="static"
        size="md"
      >
        <Modal.Header className="h4">
          {isEditingAdjunto ? "Editar Adjunto" : "Agregar Adjunto"}
        </Modal.Header>
        <Modal.Body className="p-4">
          <Row className="mb-4">
            <Col sm="12" className="mb-3">
              <Form.Label>Descripci&oacute;n</Form.Label>

              <textarea
                type="text"
                name="adjuntoDescriptionDoc"
                id="adjuntoDescriptionDoc"
                autoComplete="off"
                onChange={(e) => {
                  handleVerificarAdjunto(e);
                }}
                className="form-control form-control-sm"
              />
            </Col>
          </Row>

          <Row>
            <Col sm="12">
              <Form.Label>
                Adjunto Archivo{" "}
                {isEditingAdjunto && (
                  <span className="text-muted" style={{ fontWeight: "normal" }}>
                    (Dejar vacío para mantener el actual)
                  </span>
                )}
              </Form.Label>

              <input
                ref={fileInputAdjuntoRef}
                type="file"
                id="adjuntoFileDoc"
                name="adjuntoFileDoc"
                onChange={(e) => {
                  handleVerificarAdjunto(e);
                  selectFileAdjunto(e);
                }}
                accept="application/pdf"
                style={{ display: "none" }}
              />

              {previewAdjunto ? (
                <div className="text-center mb-3 p-4 border rounded bg-light">
                  <div className="mb-3">
                    <i className="fas fa-file-pdf fa-3x text-danger"></i>
                  </div>
                  <p className="mb-1 fw-bold">{previewAdjunto.name}</p>
                  <p className="mb-3 text-muted" style={{ fontSize: "12px" }}>
                    {(previewAdjunto.size / 1024 / 1024).toFixed(2)} MB
                  </p>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={clearPreviewAdjunto}
                  >
                    <i className="fas fa-times me-1"></i> Quitar
                  </Button>
                </div>
              ) : (
                <div
                  onDragOver={handleDragOverAdjunto}
                  onDragLeave={handleDragLeaveAdjunto}
                  onDrop={handleDropAdjunto}
                  style={{
                    border: isDraggingAdjunto
                      ? "3px dashed #0d6efd"
                      : "3px dashed #dee2e6",
                    borderRadius: "8px",
                    padding: "40px 20px",
                    textAlign: "center",
                    backgroundColor: isDraggingAdjunto
                      ? "#f8f9fa"
                      : "transparent",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                  }}
                  onClick={() => fileInputAdjuntoRef.current.click()}
                >
                  <div className="mb-3">
                    <i
                      className={`fas fa-cloud-upload-alt fa-3x ${
                        isDraggingAdjunto ? "text-primary" : "text-muted"
                      }`}
                    ></i>
                  </div>
                  <p
                    className="mb-2"
                    style={{ fontSize: "14px", color: "#6c757d" }}
                  >
                    Arrastra un archivo PDF aquí
                  </p>
                  <p
                    className="mb-2"
                    style={{ fontSize: "14px", color: "#6c757d" }}
                  >
                    o
                  </p>
                  <ButtonIcon
                    text="Cargar archivo"
                    variant="primary"
                    icono="fas fa-upload"
                  />
                  <p
                    className="mt-3 mb-0"
                    style={{ fontSize: "12px", color: "#adb5bd" }}
                  >
                    Solo se aceptan archivos PDF
                  </p>
                </div>
              )}

              <Form.Label
                id="lbDocAlert"
                style={{ display: "none", color: "#dc3545" }}
              >
                <strong>Campo requerido.</strong>
              </Form.Label>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={btnDisabled}
            onClick={closeModalAdjunto}
          >
            Salir
          </Button>
          <Button
            variant="primary"
            disabled={btnDisabled}
            onClick={() => saveAdjuntoService()}
          >
            {isEditingAdjunto ? "Modificar" : "Registrar"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ShowServicio;
